module.exports = __webpack_public_path__ + "img/papaya.6eae98a5.jpg";